// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1eEhn","errorLogs":"EditorFooter_errorLogs__2ekKk"};